<template>
  <header class="head">
    <router-link to="/Home">
      <img :src="$baseUrl + '/upload-router-api/personPhoto/2024/11/13/1731462639647335926.png'"
        style="margin-left: 200px" alt="logo" />
      <!-- <img src="https://s3.bmp.ovh/imgs/2022/04/06/7575ce930cee2ef9.png"  alt="logo"> -->
    </router-link>
    <ul>
      <li>
        <router-link to="/Home">首页</router-link>
      </li>
      <li>
        <router-link to="/Abouts">关于我们</router-link>
      </li>
      <li>
        <router-link to="/Solutions">解决方案</router-link>
      </li>
      <li>
        <router-link to="/News">新闻中心</router-link>
      </li>
      <li>
        <router-link to="/ServiceSupport">服务支持</router-link>
      </li>
      <li>
        <router-link to="/RecruitTalents">招纳贤才</router-link>
      </li>
      <!-- <li class="li_adminlogin">
        <a href="#" click="return false">后台登录</a>
        <br />
        <div class="div_adminlogin">
          <div class="admin" @click="route(0)">数字健康云</div>
          <div class="admin" @click="route(1)">数字慢病监管系统</div>
          <div class="admin" @click="route(2)">添加新闻</div>
        </div>
      </li> -->
    </ul>
  </header>
</template>
<script>
export default {
  methods: {
    route(index) {
      let path = "";
      switch (index) {
        case 0:
          path = "https://jxhnznsb.com/admin-static/#/";
          window.open(path, "_blank"); // 在新窗口打开外链接
          break;
        case 1:
          path =
            "https://jxhnznsb.com/supervision-static/#/Login?redirect=%2Fhome";
          window.open(path, "_blank"); // 在新窗口打开外链接
          break;
        //添加新闻
        case 2:
          this.$router.push({
            path: "/Addnews",
          });
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
header {
  position: fixed;
  top: 0;
  z-index: 999;
  width: 100%;
  min-width: 1200px;
  height: 90px;
  padding-left: 66px;
  padding-right: 138px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  img {
    height: 54px;
  }

  ul {
    display: flex;

    li {
      font-size: 16px;

      &:not(:first-child) {
        margin-left: 81px;
      }
    }

    a {
      text-decoration: none;
      color: #ffffff;

      &:hover {
        color: #2525cc;
      }
    }

    .router-link-active {
      color: #ffffff;
      padding-bottom: 10px;
      border-bottom: 2px solid #ffffff;
    }
  }

  .div_adminlogin {
    display: none;
    margin-top: 20px;

    .admin {
      cursor: pointer;
      margin-top: 10px;
    }

    .admin:hover {
      color: #ffffff;
    }
  }

  .li_adminlogin {
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .li_adminlogin:hover {
    padding-top: 6px;
    width: 150px;
    height: 151px;
    background: rgba(0, 0, 0, 0.39);
    opacity: 0.5;
    border-radius: 4px;

    .div_adminlogin {
      display: inline;
      text-align: center;
      position: fixed;
      z-index: 1;
      color: #b7b7b7;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Layout/HomeHeader.vue